import { esSlideshowPalettes } from "../../../../Posts/05-tematicas/06-diapositivas/slideshowPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esSlideshowPalettes,
  localizeTematicPalettes,
  React
};